module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 _.each(_.range(max_players_size), function(index){
	var player = compare[index] || {};
	if(player.id) { 
__p+='\n		<div class="compare-board-item-container">\n			<div class="compare-board-item">\n				<div class="compare-board-item-top">\n					<div class="compare-board-item-main">\n						<a class="icon icon-favourite compare-board-item-btn compare-board-item-favourite js-favourite-player '+
((__t=( player.is_favourite ? 'is-favourite' : '' ))==null?'':_.escape(__t))+
'"\n						   data-index="'+
((__t=( index ))==null?'':_.escape(__t))+
'"\n						   data-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'">\n							<i class="ion-android-star"></i>\n						</a>\n						<div class="figure">\n							<figure>\n								<picture>\n									<source srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n									<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'" alt="">\n								</picture>\n							</figure>\n						</div>\n						<a class="compare-board-item-btn compare-board-item-remove js-remove-player"\n						   data-index="'+
((__t=( index ))==null?'':_.escape(__t))+
'"\n						   data-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'">\n							<i class="ion-close-round"></i>\n						</a>\n					</div>\n					<div class="compare-board-item-player-name">\n						<i class="player-status '+
((__t=( status ))==null?'':_.escape(__t))+
'"></i>\n						<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n					</div>\n				</div>\n			</div>\n			<div class="stats-list">\n				';
 _.each(stats, function(stat){ 
__p+='\n					<div class="stat-item '+
((__t=( stat.is_coach_only ? 'stat-item-coach' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( player.max_stats.includes(stat.key) ? 'is-max' : '' ))==null?'':_.escape(__t))+
'">\n						<h5 class="stat-item-title">'+
((__t=( typeof stat.title === 'function' ? stat.title() : stat.title ))==null?'':_.escape(__t))+
'</h5>\n						<div class="stat-item-value">'+
((__t=( stat.processing(_.result(player, stat.key), '-') ))==null?'':_.escape(__t))+
'</div>\n					</div>\n				';
 }) 
__p+='\n			</div>\n			<div class="stat-box">\n				<div class="stat-box-header '+
((__t=( colors[index] ))==null?'':_.escape(__t))+
'">Last 3 / Next 3</div>\n				<ul class="stat-box-body">\n					';
 _.each(rounds_range, function(round){ 
__p+='\n					<li class="'+
((__t=( round.is_coach && has_assistant_coach ? 'is-coach-data' : '' ))==null?'':_.escape(__t))+
'">\n						<div class="col col-1">'+
((__t=( round.id ))==null?'':_.escape(__t))+
'</div>\n						<div class="col col-2">\n							';
 if(player.stats_table[round.id].opponent.id){ 
__p+='\n								<img class="squad-logo" src="'+
((__t=( SQUADS_PATH + player.stats_table[round.id].opponent.id ))==null?'':_.escape(__t))+
'.png" alt="">\n							';
 } 
__p+='\n						</div>\n						<div class="col col-3">\n							';
 if(!(_.eq(player.stats_table[round.id].price.change, 'none') && round.is_coach && !has_assistant_coach)){ 
__p+='\n							<i class="price-change-dir '+
((__t=( player.stats_table[round.id].price.change ))==null?'':_.escape(__t))+
'"></i>\n							';
 } 
__p+='\n							<span>'+
((__t=( player.stats_table[round.id].price.value ))==null?'':_.escape(__t))+
'</span>\n						</div>\n						<div class="col col-4">\n							';
 if(round.is_coach && _.isNumber(player.stats_table[round.id].points)){ 
__p+='\n							<span>'+
((__t=( player.stats_table[round.id].points ))==null?'':_.escape(__t))+
'</span>\n							';
 } else { print(player.stats_table[round.id].points) } 
__p+='\n						</div>\n					</li>\n					';
 }) 
__p+='\n				</ul>\n				<a href="/player-profile/'+
((__t=( player.id ))==null?'':_.escape(__t))+
'" target="_blank" class="btn">FULL PROFILE</a>\n			</div>\n		</div>\n	';
 } else { 
__p+='\n		<div class="stat-box-empty">\n			<i class="icon-plus ion-plus"></i>\n			<span>Add Player</span>\n		</div>\n	';
 } 
__p+='\n';
 }) 
__p+='';
}
return __p;
};
